import { KeyboardEvent, useCallback, useEffect, useState } from "react";

import TextSearchResult from "@app/types/TextSearchResult";

import useEntityMentionSearch from "./useEntityMentionSearch";

interface MentionKeyHandlers {
  onHide: () => void;
  onSelect: (result: TextSearchResult) => void;
}

const useEntityMentionSuggestions = (query: string) => {
  const { loading, results } = useEntityMentionSearch(query);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [results]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent, { onHide, onSelect }: MentionKeyHandlers): boolean => {
      if (event.key === "ArrowDown") {
        setActiveIndex((index) => (index < results.length - 1 ? index + 1 : index));
      } else if (event.key === "ArrowUp") {
        setActiveIndex((index) => (index > 0 ? index - 1 : index));
      } else if (event.key === "Enter") {
        const result = results[activeIndex];
        if (!result) {
          return false;
        }
        onSelect(result);
      } else if (event.key === "Escape") {
        onHide();
      } else {
        return false;
      }
      event.preventDefault();
      event.stopPropagation();
      return true;
    },
    [activeIndex, results]
  );

  return { activeIndex, handleKeyDown, loading, results, setActiveIndex };
};

export default useEntityMentionSuggestions;
